class SlideShow {
    constructor() {
        let e = this,
            t = document.querySelectorAll(".carousel");
        t &&
            t.forEach((t) => {
                let i = "true" === t.dataset.dots,
                    s = Array.from(t.querySelectorAll(".carousel__slide")),
                    a = "false" != t.dataset.autoplay && parseInt(t.dataset.autoplay, 10),
                    o = "center" == t.dataset.align ? "center" : "left",
                    l = "true" == t.dataset.fade,
                    r = t.querySelector(".flickity-prev"),
                    n = t.querySelector(".flickity-next"),
                    c = t.querySelector(".flickity-page-dots"),
                    d = t.parentNode.querySelector(".flickity-progress--bar"),
                    u = [],
                    y = "rtl" === document.dir,
                    h = document.body.classList.contains("animations-true") && "undefined" != typeof gsap,
                    m = 0,
                    p = {
                        wrapAround: !0,
                        cellAlign: o,
                        pageDots: !1,
                        contain: !0,
                        fade: l,
                        autoPlay: a,
                        rightToLeft: y,
                        prevNextButtons: !1,
                        cellSelector: ".carousel__slide",
                        on: {},
                    };
                if (s.length < 1) return;
                if (t.classList.contains("image-with-text-slideshow__image")) {
                    let e = t.parentNode.querySelector(".image-with-text-slideshow__content"),
                        i = t.querySelectorAll(".image-with-text-slideshow__image-media");
                    (p.draggable = !1),
                        (p.asNavFor = e),
                        i.length && i[0].classList.contains("desktop-height-auto") && (p.adaptiveHeight = !0);
                }
                if (t.classList.contains("customer-reviews__image")) {
                    let e = t.parentNode.querySelector(".customer-reviews__content");
                    (p.draggable = !1), (p.asNavFor = e);
                }
                (t.classList.contains("image-with-text-slideshow__content") ||
                    t.classList.contains("testimonials__carousel") ||
                    t.classList.contains("customer-reviews__content") ||
                    t.classList.contains("customer-reviews__image")) &&
                    (p.adaptiveHeight = !0),
                    t.classList.contains("custom-dots") &&
                        (h && t.classList.contains("main-slideshow") && e.prepareAnimations(t, u),
                        (p.pauseAutoPlayOnHover = !1),
                        (p.on = {
                            staticClick: function () {
                                this.unpausePlayer();
                            },
                            ready: function () {
                                let s = this;
                                if ((h && t.classList.contains("main-slideshow") && e.animateSlides(0, t, u), i && c)) {
                                    let e = c.querySelectorAll("li");
                                    e.forEach((e, t) => {
                                        e.addEventListener("click", (e) => {
                                            s.select(t);
                                        });
                                    }),
                                        e[this.selectedIndex].classList.add("is-selected");
                                }
                                document.fonts.ready.then(function () {
                                    s.resize();
                                });
                                let a = s.cells[0].element.querySelector(".slideshow__slide-video-bg");
                                a &&
                                    (a.querySelector("iframe")
                                        ? (a.querySelector("iframe").onload = function () {
                                              e.videoPlay(a);
                                          })
                                        : a.querySelector("video") &&
                                          (a.querySelector("video").onloadstart = function () {
                                              e.videoPlay(a);
                                          }));
                            },
                            change: function (s) {
                                let o = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length);
                                if (
                                    (h &&
                                        t.classList.contains("main-slideshow") &&
                                        (setTimeout(() => {
                                            e.animateReverse(o, t, u);
                                        }, 300),
                                        e.animateSlides(s, t, u)),
                                    i && c)
                                ) {
                                    let e = c.querySelectorAll("li");
                                    e.forEach((e, t) => {
                                        e.classList.remove("is-selected");
                                    }),
                                        e[this.selectedIndex].classList.add("is-selected");
                                }
                                a && (this.stopPlayer(), this.playPlayer());
                                let l = g.cells[o].element.querySelector(".slideshow__slide-video-bg");
                                l && e.videoPause(l);
                                let r = g.cells[s].element.querySelector(".slideshow__slide-video-bg");
                                r &&
                                    (r.querySelector("iframe")
                                        ? r.querySelector("iframe").classList.contains("lazyload")
                                            ? (r
                                                  .querySelector("iframe")
                                                  .addEventListener("lazybeforeunveil", e.videoPlay(r)),
                                              lazySizes.loader.checkElems())
                                            : e.videoPlay(r)
                                        : r.querySelector("video") && e.videoPlay(r));
                            },
                        })),
                    t.classList.contains("main-slideshow") &&
                        (t.classList.contains("desktop-height-image") || t.classList.contains("mobile-height-image")) &&
                        (p.adaptiveHeight = !0),
                    t.classList.contains("products") &&
                        ((p.wrapAround = !1),
                        (p.on.ready = function () {
                            var i = this;
                            n &&
                                window.addEventListener("resize.center_arrows", function () {
                                    e.centerArrows(i, t, r, n);
                                }),
                                window.dispatchEvent(new Event("resize.center_arrows"));
                        })),
                    d &&
                        ((p.wrapAround = !1),
                        (p.on.scroll = function (e) {
                            (e = Math.max(0, Math.min(1, e))), (d.style.width = 100 * e + "%");
                        }));
                const g = new Flickity(t, p);
                (m = g.selectedIndex),
                    (t.dataset.initiated = !0),
                    r &&
                        (r.addEventListener("click", (e) => {
                            g.previous();
                        }),
                        r.addEventListener("keyup", (e) => {
                            g.previous();
                        }),
                        n.addEventListener("click", (e) => {
                            g.next();
                        }),
                        n.addEventListener("keyup", (e) => {
                            g.next();
                        })),
                    Shopify.designMode &&
                        t.addEventListener("shopify:block:select", (e) => {
                            let t = s.indexOf(e.target);
                            g.select(t);
                        });
            });
    }
    videoPause(e) {
        setTimeout(() => {
            "hosted" === e.dataset.provider
                ? e.querySelector("video").pause()
                : "youtube" === e.dataset.provider
                  ? e
                        .querySelector("iframe")
                        .contentWindow.postMessage(
                            JSON.stringify({ event: "command", func: "pauseVideo", args: "" }),
                            "*"
                        )
                  : "vimeo" === e.dataset.provider &&
                    e.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ method: "pause" }), "*");
        }, 10);
    }
    videoPlay(e) {
        setTimeout(() => {
            "hosted" === e.dataset.provider
                ? e.querySelector("video").play()
                : "youtube" === e.dataset.provider
                  ? e
                        .querySelector("iframe")
                        .contentWindow.postMessage(
                            JSON.stringify({ event: "command", func: "playVideo", args: "" }),
                            "*"
                        )
                  : "vimeo" === e.dataset.provider &&
                    e.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ method: "play" }), "*");
        }, 10);
    }
    prepareAnimations(e, t) {
        e.dataset.animationsReady ||
            (new SplitText(e.querySelectorAll("h1, p:not(.subheading)"), {
                type: "lines, words",
                linesClass: "line-child",
            }),
           
            // e.querySelectorAll(".slideshow__slide").forEach((i, s) => {
            //     let a = gsap.timeline({ paused: !0 }),
            //         o = 0;
            //     if (
            //         ((t[s] = a),
            //         "swipe" == e.dataset.transition &&
            //             a.to(i, { duration: 0.7, clipPath: "polygon(100% 0, 0 0, 0 100%, 100% 100%)" }, "start"),
            //         a.to(i.querySelector(".slideshow__slide-bg"), { duration: 1.5, scale: 1 }, "start"),
            //         i.querySelector(".subheading") &&
            //             (a.fromTo(i.querySelector(".subheading"), { opacity: 0 }, { duration: 0.5, opacity: 1 }, 0),
            //             (o += 0.5)),
            //         i.querySelector("h1"))
            //     ) {
            //         let e = 0.5 + 0.05 * (i.querySelectorAll("h1 .line-child div").length - 1);
            //         a.from(
            //             i.querySelectorAll("h1 .line-child div"),
            //             { duration: e, yPercent: "100", stagger: 0.05 },
            //             0
            //         ),
            //             (o += e);
            //     }
            //     if (i.querySelector("p:not(.subheading)")) {
            //         let e = 0.5 + 0.02 * (i.querySelectorAll("p:not(.subheading) .line-child div").length - 1);
            //         a.from(
            //             i.querySelectorAll("p:not(.subheading) .line-child div"),
            //             { duration: e, yPercent: "100", stagger: 0.02 },
            //             0
            //         ),
            //             (o += e);
            //     }
            //     i.querySelectorAll(".button") &&
            //         a.fromTo(
            //             i.querySelectorAll(".button"),
            //             { y: "100%" },
            //             { duration: 0.5, y: "0%", stagger: 0.1 },
            //             0.2 * o
            //         ),
            //         (i.dataset.timeline = a);
            // }),
            (e.dataset.animationsReady = !0));
            let tlnew = gsap.timeline();
            tlnew.to(".slideshow h1 .line-child div",{
                delay:0.5,
                y: "0", 
                stagger: 0.05,
                duration:1
            });
            tlnew.to(".slideshow p .line-child div",{
                y: "0", 
                stagger: 0.02,
                duration:1
            },"<")
            tlnew.to(".slideshow a.button",{
                 y: "0",
                duration:1
            },"<")
    }
    animateSlides(e, t, i) {
        Flickity.data(t).selectedElement;
        document.fonts.ready.then(function () {
            i[e].timeScale(1).restart();
        });
    }
    animateReverse(e, t, i) {
        i[e].timeScale(3).reverse();
    }
    centerArrows(e, t, i, s) {
        let a = e.cells[0],
            o = 0,
            l = a.element.querySelector(".product-featured-image").clientHeight;
        if (
            (e.cells.forEach((e, t) => {
                e.size.height > o && (o = e.size.height);
            }),
            o > l)
        ) {
            let e = (o - l) / -2;
            (i.style.transform = "translateY(" + e + "px)"), (s.style.transform = "translateY(" + e + "px)");
        }
    }
}
void 0 !== SlideShow && new SlideShow();
